<template>
    <div class="price-box" :style="{textAlign: textAlign}">
        <div class="saleP" v-if="showPriceArray.length > 1" :style="{color: showPriceColor}">
            <i>￥</i>{{showPriceArray[0]}}<i>.{{showPriceArray[1]}}</i>
            <i class="originP" v-if="showOrigin && !showOriginColumn" :style="{color: cancelPriceColor}">￥{{cancelPrice}}</i>
        </div>
        <div class="saleP" :style="{color: showPriceColor}" v-else>
            <i>￥</i>{{showPrice}}
            <i class="originP ml8" v-if="showOrigin && !showOriginColumn" :style="{color: cancelPriceColor}">￥{{cancelPrice}}</i>
        </div>
        <i class="originP" v-if="showOrigin && showOriginColumn" :style="{color: cancelPriceColor}">￥{{cancelPrice}}</i>
    </div>
</template>
<script>
export default {
    name: 'priceShow',
    props: {
        // 价格显示位置
        textAlign: {
            type: String,
            default: 'left'
        },
        // 展示的价格
        showPrice: {
            type: [String, Number],
            default: 0,
            required: true
        },
        // 展示价格的颜色
        showPriceColor: {
            type: String,
            default: '#ff4d4f'
        },
        // 是否显示被划掉的价格
        showOrigin: {
            type: Boolean,
            default: false
        },
        // 价格横着展示还是竖着展示
        showOriginColumn: {
            type: Boolean,
            default: true
        },
        // 被划掉的价格
        cancelPrice: {
            type: [String, Number],
            default: 0
        },
        // 被划掉价格的颜色
        cancelPriceColor: {
            type: String,
            default: '#999999'
        }
    },
    computed: {
        // 将价格以.分割成数组，区分整数和小数
        showPriceArray () {
            return this.showPrice.toString().split('.')
        }
    }
}
</script>

<style lang="scss" scoped>
.price-box {
    width: 100%;
    font-family: PingFangSC;
    .saleP {
        font-weight: bold;
        height: 48px;
        font-size: 34px;
        line-height: 48px;
        i {
            display: inline-block;
            font-size: 24px;
            transform: scale(0.92);
            transform-origin: left 80%;
        }
    }
    .originP {
        height: 28px;
        line-height: 28px;
        font-size: 24px;
        text-decoration: line-through;
        transform: scale(0.83);
        transform-origin: left 80%;
        &.ml8 {
            margin-left: 8px;
        }
    }
}
</style>